<ct-form *ngIf="configuration" [configuration]="configuration"></ct-form>

<div fxLayout="row wrap" fxLayoutAlign="space-between center">
  <ct-button [configuration]="cancelButton"></ct-button>
  <ct-button [configuration]="submitButton"></ct-button>
</div>